<form
  class="form-b4a"
  [formGroup]="form"
  (ngSubmit)="save()"
  *ngIf="isCreate || post"
>
  <h3>{{ isCreate ? 'Novo post' : 'Detalhes do post' }}</h3>

  <div class="field-block full-w" *ngIf="!isCreate">
    <label>URL do post</label>
    <a
      *ngIf="post.postUrl"
      class="post-url"
      [href]="post.postUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ post.postUrl }}
    </a>
    <span *ngIf="!post.postUrl">—</span>
  </div>

  <span class="p-float-label full-w" *ngIf="isCreate">
    <input
      type="text"
      pInputText
      formControlName="postUrl"
      id="postUrl"
      [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('postUrl') }"
    />
    <label for="postUrl">URL do post *</label>
    <small class="error" *ngIf="invalidControl('postUrl')">
      A URL do post é obrigatória.
    </small>
  </span>

  <div class="form-row">
    <span class="p-float-label">
      <input
        type="text"
        pInputText
        formControlName="personAccount"
        id="personAccount"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('personAccount') }"
      />
      <label for="personAccount">Conta{{ isCreate ? ' *' : '' }}</label>
      <small class="error" *ngIf="invalidControl('personAccount')">
        A conta é obrigatória.
      </small>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        formControlName="personId"
        inputId="personId"
        [useGrouping]="false"
      />
      <label for="personId">Person ID</label>
    </span>
  </div>

  <div class="form-row">
    <div class="input-switch form-row__active">
      <p-inputSwitch formControlName="consent" inputId="consent" />
      <label for="consent">Consentimento</label>
    </div>
    <span class="p-float-label">
      <p-calendar
        formControlName="consentDate"
        inputId="consentDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [showTime]="true"
        [style]="{ width: '100%' }"
      />
      <label for="consentDate">Data do consentimento</label>
    </span>
    <span class="p-float-label" *ngIf="!isCreate">
      <p-calendar
        formControlName="createdAt"
        inputId="createdAt"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [showTime]="true"
        [style]="{ width: '100%' }"
      />
      <label for="createdAt">Criado em</label>
    </span>
  </div>

  <div class="form-row">
    <span class="p-float-label">
      <input
        type="text"
        pInputText
        formControlName="ipAddress"
        id="ipAddress"
      />
      <label for="ipAddress">IP</label>
    </span>
    <span class="p-float-label">
      <input type="text" pInputText formControlName="platform" id="platform" />
      <label for="platform">Plataforma</label>
    </span>
  </div>

  <span class="p-float-label full-w">
    <textarea
      pInputTextarea
      rows="2"
      formControlName="userAgent"
      id="userAgent"
    ></textarea>
    <label for="userAgent">User agent</label>
  </span>

  <h4>Avaliação</h4>

  <div class="form-row">
    <div class="input-switch form-row__active">
      <p-inputSwitch formControlName="approved" inputId="approved" />
      <label for="approved">Aprovado</label>
    </div>
    <span class="p-float-label">
      <p-inputNumber
        formControlName="rating"
        inputId="rating"
        [min]="0"
        [useGrouping]="false"
      />
      <label for="rating">Nota</label>
    </span>
    <span class="p-float-label">
      <input type="text" pInputText formControlName="status" id="status" />
      <label for="status">Status</label>
    </span>
  </div>

  <span class="p-float-label full-w">
    <textarea
      pInputTextarea
      rows="5"
      formControlName="postAnalysis"
      id="postAnalysis"
    ></textarea>
    <label for="postAnalysis">Análise</label>
  </span>

  <div class="buttons">
    <p-button
      type="button"
      [outlined]="true"
      severity="secondary"
      label="Cancelar"
      (onClick)="goBack()"
    />
    <p-button type="submit" label="Salvar" [disabled]="form.invalid" />
  </div>
</form>
